import(/* webpackMode: "eager" */ "/vercel/path1/apps/web/src/app/page.tsx");
